import React from "react"

//Bootstrap
import { Container, Col, Row, Accordion, Card, Button } from "react-bootstrap"

//Icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCaretDown } from "@fortawesome/free-solid-svg-icons"

const QuestionSection = () => {
  return (
    <section id="FAQ-section">
      <Container className="FAQ-container">
        <Col md={10}>
          <h2 className="header-text">Questions about Addiction</h2>
          {AddictionQuestion.map((data, key) => (
            <QuestionCard header={data.header} text={data.text} />
          ))}{" "}
        </Col>
      </Container>
      <Container className="FAQ-container">
        <Col md={10}>
          <h2 className="header-text">Questions about Rehab</h2>
          {RehabQuestion.map((data, key) => (
            <QuestionCard header={data.header} text={data.text} />
          ))}{" "}
        </Col>
      </Container>
    </section>
  )
}
export default QuestionSection

const QuestionCard = ({ header, text }) => {
  return (
    <Accordion className="accordition">
      <Card className="accordition-card">
        <Accordion.Toggle
          style={{
            backgroundColor: "white",
            height: "60px",
            alignItems: "center",
            display: "flex",
          }}
          as={Card.Header}
          eventKey="0"
        >
          <div className="card-box">
            <span>{header}</span>
            <FontAwesomeIcon icon={faCaretDown} />
          </div>
        </Accordion.Toggle>
        <Accordion.Collapse style={{ border: "none" }} eventKey="0">
          <Card.Body>{text}</Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  )
}

const AddictionQuestion = [
  { header: "What causes addiction?", text: "" },
  { header: "If I try a drug just once, can I become addicted?", text: "" },
  {
    header: "How can I tell if someone I love is addicted to drugs or alcohol?",
    text: "",
  },
  {
    header: "Is it true that once you’re an addict, you’re an addict for life?",
    text: "",
  },
]
const RehabQuestion = [
  {
    header: "Is inpatient rehab expensive?",
    text:
      "The cost of inpatient rehab depends on the facility and the services it offers. A lot of people are discouraged from considering inpatient programs, because in general, they do cost significantly more than outpatient programs. However, the cost of inpatient rehab includes many things, such as the following: A comfortable living space that ranges from a private room to shared accommodations, depending on the facility Meals that are nutritious and, in many cases, prepared by an in-house chef All group and individual therapy sessions Educational sessions Access to a gym, facility grounds, recreational activities, libraries and more Around the clock care and support",
  },
  { header: "How long does an inpatient rehab program last?", text: "" },
  {
    header: "Is outpatient rehab as good as inpatient rehab?",
    text: "",
  },
  {
    header: "Don’t a lot of people relapse after they finish rehab?",
    text: "",
  },
]
